import React, { Component } from 'react';
import { connect } from 'react-redux';

class EventTitle extends Component {
  render() {
    return (
      <div className="container__react section--light p-t-lg">
        <div className="container-fluid">
          <div className="section__header">
            <div className="text-center section__title">
              <h1 className="section__title--full">{this.props.title}</h1>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default EventTitle;
